import { post } from '@/lib/request/index';
import { common } from '../apiConstants';
// 获取号码保护的虚拟电话
export function getVirtualtelCall(param) {
  return post(common.PROTECT_NUM, {
    param,
  });
}
// 获取token
export function getToken(param) {
  return post(common.GET_TOKEN, { param });
}
// 获取枚举
export function getEnums(param) {
  return post(common.GET_ENUM, { param })
    .then((data) => data)
    .catch((err) => {
      console.log('err', err);
      return false;
    });
}
